// extracted by mini-css-extract-plugin
export default {"popupBox":"index_popupBox_MhVVn","popup":"index_popup_8Iste","popupPic":"index_popupPic_dAky-","popupQrcode":"index_popupQrcode_JoR2R","popupClose":"index_popupClose_-PXe0"};